import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';
import TextEditor from '../TextEditor';

const propTypes = {
  value: PropTypes.string,
  edit: PropTypes.bool,
  inherit: PropTypes.bool,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onSelectChange: PropTypes.func,
  displayTypeSelect: PropTypes.bool,
  dropDownOptions: PropTypes.arrayOf(PropTypes.object),
  indexOfContentType: PropTypes.number,
};

const defaultProps = {
  edit: false,
  inherit: false,
  onChange: null,
  onSave: null,
  onCancel: null,
  onSelectChange: null,
  value: null,
  displayTypeSelect: false,
  dropDownOptions: null,
  indexOfContentType: null,
};


export default function PlainContent({
  edit, inherit, onChange, onSave, onCancel, onSelectChange, value, displayTypeSelect,
  dropDownOptions, indexOfContentType,
}) {
  if (!edit) {
    const renderedValue = (value || '').split('\n').map((lineContent, index) => (
      // eslint-disable-next-line react/no-array-index-key
      lineContent === '' ? <br key={index} />
        // eslint-disable-next-line react/no-array-index-key
        : <Text key={index} appearance="prose" inherit={inherit}>{lineContent}</Text>
    ));
    return renderedValue;
  }

  return (
    <TextEditor
      displayTypeSelect={displayTypeSelect}
      onChange={onChange}
      onSave={onSave}
      onCancel={onCancel}
      onSelectChange={onSelectChange}
      dropDownOptions={dropDownOptions}
      indexOfContentType={indexOfContentType}
      defaultValue={value}
    />
  );
}


PlainContent.propTypes = propTypes;
PlainContent.defaultProps = defaultProps;
